/**
 * Trunca el texto de un mensaje para la vista previa.
 * No extiende el corte hasta el final de URLs largas (eso impedía "Mostrar completo").
 */
export function truncateMessageContent(content, maxLength) {
  const text = content || "";
  if (text.length <= maxLength) {
    return { text, wasTruncated: false };
  }
  return {
    text: `${text.substring(0, maxLength)}...`,
    wasTruncated: true,
  };
}

/** Máximo de caracteres visibles por enlace en la vista previa truncada. */
export const MAX_URL_PREVIEW_CHARS = 120;

function shortenUrl(url, maxUrlLength) {
  if (!url || url.length <= maxUrlLength) return url;
  return `${url.slice(0, maxUrlLength)}…`;
}

/**
 * Acorta URLs largas solo en el texto de vista previa (no afecta "Mostrar completo").
 */
export function shortenLongUrlsInText(text, maxUrlLength = MAX_URL_PREVIEW_CHARS) {
  if (!text) return text;

  let result = text.replace(
    /\]\((https?:\/\/[^)\s]+)\)/gi,
    (_, url) => `](${shortenUrl(url, maxUrlLength)})`
  );

  result = result.replace(/https?:\/\/[^\s\])]+/gi, (url) =>
    shortenUrl(url, maxUrlLength)
  );

  result = result.replace(/www\.[^\s\])]+/gi, (url) =>
    shortenUrl(url, maxUrlLength)
  );

  return result;
}

/** Estilos para que URLs y texto largo sin espacios hagan wrap dentro del contenedor. */
export const messageContentTypographySx = {
  lineHeight: 1.5,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  overflowWrap: "anywhere",
  maxWidth: "100%",
};
